import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HeroSection() {
  return (
    <section className="relative bg-slate-900 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 opacity-90" />
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920')] bg-cover bg-center opacity-20" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-6">
              Technology Consulting Services
            </p>
            <h1 
              data-testid="hero-title"
              className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none text-white font-['Outfit'] mb-6"
            >
              Your Trusted Technology Partner
            </h1>
            <p className="text-lg text-slate-300 leading-relaxed mb-8 max-w-xl font-['Plus_Jakarta_Sans']">
              At Nidus, we empower businesses with innovative technology solutions to thrive 
              in the digital age. Our passion for technology, combined with our commitment to 
              excellence, enables us to deliver tailored solutions that drive success.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button 
                  data-testid="hero-cta-primary"
                  className="bg-blue-700 hover:bg-blue-800 text-white rounded-none px-8 py-6 text-base w-full sm:w-auto"
                >
                  Start Your Journey
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Link to="/case-studies">
                <Button 
                  data-testid="hero-cta-secondary"
                  variant="outline"
                  className="border-white text-white hover:bg-white hover:text-slate-900 rounded-none px-8 py-6 text-base w-full sm:w-auto"
                >
                  View Case Studies
                </Button>
              </Link>
            </div>
          </div>
          
          <div className="lg:col-span-5 hidden lg:grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="aspect-square rounded-none overflow-hidden border border-slate-700">
                <img 
                  src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400" 
                  alt="AI Technology" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-video rounded-none overflow-hidden border border-slate-700">
                <img 
                  src="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400" 
                  alt="Data Analytics" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="aspect-video rounded-none overflow-hidden border border-slate-700">
                <img 
                  src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400" 
                  alt="Cloud Services" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-none overflow-hidden border border-slate-700">
                <img 
                  src="https://images.unsplash.com/photo-1573164713988-8665fc963095?w=400" 
                  alt="Software Development" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
